import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import { ThemeProvider } from '@mui/material/styles';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import * as React from 'react';
import { useCallback } from 'react';
import { createGetAccountInfoOutbound, createShowBlockedPlayersOutbound } from '../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../components/menuItemContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { showSettingsMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
import { darkTheme } from '../../styles/materialTheme';
import { RefreshSelfPanelMenuItem } from './refreshSelfPanelMenuItem';
export const SelfPanelActionsMenuButton = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickAccount = React.useCallback(() => {
        socketSend(createGetAccountInfoOutbound());
    }, [socketSend]);
    const onClickSettings = useCallback(() => {
        dispatch(showSettingsMessageBox());
    }, [dispatch]);
    const onClickShowBlockedPlayers = useCallback(() => {
        socketSend(createShowBlockedPlayersOutbound());
    }, [socketSend]);
    const popupState = usePopupState({ variant: 'popover' });
    return (_jsxs("div", { children: [_jsx(IconButton, { size: 'small', title: 'Actions', color: 'primary', ...bindTrigger(popupState), children: _jsx(MenuRoundedIcon, {}) }), _jsx(ThemeProvider, { theme: darkTheme, children: _jsxs(Menu, { ...bindMenu(popupState), children: [_jsx(MenuItemContainer, { label: 'Account', svgIconComponent: ManageAccountsRoundedIcon, onClick: onClickAccount, closeMenu: popupState.close }), _jsx(MenuItemContainer, { label: 'Settings', svgIconComponent: SettingsRoundedIcon, onClick: onClickSettings, closeMenu: popupState.close }), _jsx(MenuItemContainer, { label: 'Blocked Players', svgIconComponent: DoDisturbOnRoundedIcon, onClick: onClickShowBlockedPlayers, closeMenu: popupState.close }), _jsx(Divider, {}), _jsx(RefreshSelfPanelMenuItem, { closeMenu: popupState.close })] }) })] }));
};
